import { useTheme } from 'styled-components'

import { FormLabel } from './FormLabel'

interface IProps {
  label?: string
  mb?: number
  isChecked?: boolean
  value?: boolean
  onToggle?: (value: boolean) => void
  onChange?: (value: boolean) => void
  [key: string]: unknown
}

export function FormSwitch({ label, mb, isChecked, value, onToggle, onChange, ...rest }: IProps) {
  const { colors } = useTheme()
  const checked = value ?? isChecked ?? false

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onToggle?.(e.target.checked)
    onChange?.(e.target.checked)
  }

  return (
    <div style={{ marginBottom: mb, minHeight: 44, display: 'flex', alignItems: 'center' }}>
      <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
        <FormLabel>{label}</FormLabel>
        <input
          type="checkbox"
          role="switch"
          checked={checked}
          onChange={handleChange}
          style={{ accentColor: colors.switchSlider, width: 20, height: 20 }}
        />
      </div>
    </div>
  )
}
